import { Program } from '@coral-xyz/anchor';
import {
	DriftClient,
	FuelOverflowAccount,
	UserAccount,
	UserStatsAccount,
} from '@drift-labs/sdk';
import { Vault, DriftVaults } from '@drift-labs/vaults-sdk';

export const vaultDataDecoder = (
	buffer: Buffer,
	vaultProgram: Program<DriftVaults>
): Vault => {
	const account = vaultProgram.account.vault.coder.accounts.decode(
		'vault',
		buffer
	);
	return account;
};

export const userStatsDataDecoder = (
	buffer: Buffer,
	driftProgram: DriftClient['program']
): UserStatsAccount => {
	const account = driftProgram.account.userStats.coder.accounts.decodeUnchecked(
		'UserStats',
		buffer
	);
	return account;
};

export const fuelOverflowAccountDataDecoder = (
	buffer: Buffer,
	driftProgram: DriftClient['program']
): FuelOverflowAccount => {
	const account =
		driftProgram.account.fuelOverflow.coder.accounts.decodeUnchecked(
			'FuelOverflow',
			buffer
		);
	return account;
};

export const userAccountDataDecoder = (
	buffer: Buffer,
	driftProgram: DriftClient['program']
): UserAccount => {
	const account = driftProgram.account.user.coder.accounts.decodeUnchecked(
		'User',
		buffer
	);
	return account;
};
